import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import images from '../images'
import { theme, breakpoints } from '../ui-config'
import { SectionalHeader } from './core'

// Custom projects, slowly transitioning this over
import activeCustomProjects from './projects/active'

const vertMargin = 4;
const minWidth = 230;

const Container = styled.div`
    margin: 40px auto 100px auto;
    max-width: ${breakpoints.large}px;
`

const StyledGallery = styled.div`
    display: flex;
    flex-wrap: wrap;
`

const StyledLink = styled(Link)`
    position: relative;
    top: 0;
    transition: 200ms all ease-in-out 0s;
    text-decoration: none;
    margin-bottom: 5px;
    display: block;

    &:hover {
        transform: scale(0.9);
    }
`
const StyledA = styled.a`
    position: relative;
    top: 0;
    transition: 200ms all ease-in-out 0s;
    text-decoration: none;
    margin-bottom: 5px;
    display: block;

    &:hover {
        transform: scale(0.9);
    }
`

const ProjectImage = styled.img`
    width: 100%;
    box-shadow: 3px 4px 7px rgba(0,0,0,0.15);
    position: relative;
    &::after {
        content: '';
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        opacity: 0;
        box-shadow: 0 5px 15px rgba(0,0,0,0.3);
        transition: opacity 0.3s ease-in-out;
    }
    &:hover::after {
        opacity: 1;
    }
`

const ProjectTitle = styled.div`
    color: ${theme.inverseText};
    background-color: ${theme.shadow};
    margin: 0;
    text-decoration: none;
    position: absolute;
    bottom: 16px;
    padding: 10px;
    text-align: left;
    text-shadow: 2px 2px 4px ${theme.shadow};
`

const Column = styled.div`
    flex: 1;
    margin: 0 ${vertMargin}px;

    @media (max-width: ${3*minWidth}px) {
        width: 100%;
        flex: none;
        margin: 0;
    }
`

export default class Gallery extends Component {

    render() {
        const { projects, exclude } = this.props
        const firstColumn = []
        const secondColumn = []
        const thirdColumn = []

        const activeProjects = projects.filter(project => project.active === "TRUE")
        const allProjects = [...activeCustomProjects, ...activeProjects].filter(p => p.title !== exclude)
        allProjects.forEach((project, index) => {
                let pic;
                if (project.linkOut) {
                    pic = <StyledA key={ project.title } href={ project.linkOut } >
                        <ProjectImage alt={ project.title } src={ images[project.galleryImage] } />
                        <ProjectTitle className="projectTitle">{ project.title }</ProjectTitle>
                    </StyledA>
                } else {
                    pic = <StyledLink key={ project.title } to={ project.title } >
                        <ProjectImage alt={ project.title } src={ images[project.galleryImage] } />
                        <ProjectTitle className="projectTitle">{ project.title }</ProjectTitle>
                    </StyledLink>
                }
                switch (index % 3) {
                    case 0:
                        firstColumn.push(pic);
                        break;
                    case 1:
                        secondColumn.push(pic);
                        break;
                    case 2:
                        thirdColumn.push(pic);
                        break;
                    default:
                        break;
                }
            })

        return (
            <Container>
                <SectionalHeader>recent work</SectionalHeader><br />
                <StyledGallery>
                    <Column style={{ marginLeft: 0 }}>{ firstColumn }</Column>
                    <Column>{ secondColumn }</Column>
                    <Column style={{ marginRight: 0 }}>{ thirdColumn }</Column>
                </StyledGallery>
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Gallery.js